import curd from '../curd'

const BASE_PATH = '/factor/standard/name'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/FactorStandard.js